export function initAndSetTitlePage(vm: any, itemName: any) {
  //check if we are on a page with deleted items
  vm.isDeletedItem = (location.hash.indexOf('/deleted') > -1) ? true : false;
  if (vm.isDeletedItem) {
      document.title = "DELETED " + itemName;
  }
}

export function initVariables(vm: any, itemName: any) {
  //sets variables according to whether we are on a page with deleted items or not
  if (vm.isDeletedItem) {
      vm.searchPlaceholder = "search deleted " + itemName + "...";
  }
  else {
      vm.searchPlaceholder = "search " + itemName + "...";
  }
}
